var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.252,
    d: "M26.5 0C41.136 0 53 11.864 53 26.5S41.136 53 26.5 53 0 41.136 0 26.5 11.864 0 26.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 19.5v6c0 1.9-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5v-6c0-1.9 1.5-3.5 3.5-3.5 1.9 0 3.5 1.6 3.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.4c.5 3.6 2.3 5.3 5.4 5.2 3-.1 4.8-1.8 5.2-5.2.1-.5.5-.9 1-.9h.6c.6 0 1 .4 1 1v.1c-.5 5.1-3.1 7.7-7.8 7.7-4.7 0-7.3-2.6-7.8-7.7-.1-.6.3-1 .9-1.1h.5c.5 0 .9.4 1 .9m1.3 9.1h8.6c.7 0 1.2.5 1.2 1.2v.6c0 .7-.5 1.2-1.2 1.2h-8.6c-.7 0-1.2-.5-1.2-1.2v-.6c0-.7.5-1.2 1.2-1.2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/AudioIcon.e02d7244cc2b26c6c92d64e5c50d36eb.svg";
export { ForwardRef as ReactComponent };